import { Injectable } from '@angular/core';

import { HttpClient } from '@angular/common/http';

import { ConfigService } from '../../shared/utils/config.service';
import { BaseService } from '../../shared/services/base.service';

// Models
import { ContractorDetailsModel } from '../models/contractordetailsmodel';


@Injectable({
  providedIn: 'root'
})
export class ContractorDetailsService extends BaseService {
  baseApiUrl: string = '';
  postcontractorDetailsApiUrl: string = '';
  getcontractorDtlsByrecordIdUrl: string = '';
  deletecontractorDtlsByRecordId: string = '';
  getcontractordataDtlsByrecordIdUrl: string = '';
  getContractorUrl: string = '';
  updateUserIdContractorDetailsApiUrl: string = '';
  getUserIdContractorDetailsApiUrl: string = ''
  getUserDataFromAppenateApiUrl : string ='';

  constructor(private http: HttpClient, private configService: ConfigService) {
    super();
    this.baseApiUrl = this.configService.getApiURI();
    this.postcontractorDetailsApiUrl = this.baseApiUrl + '/ContractorDetails/AddUpdateContractorDetailsData';
    this.getcontractorDtlsByrecordIdUrl = this.baseApiUrl + '/ContractorDetails/GetContractorByRecordId';
    this.deletecontractorDtlsByRecordId = this.baseApiUrl + '/ContractorDetails/deleteContractorByRecordId';
    this.getcontractordataDtlsByrecordIdUrl = this.baseApiUrl + '/ContractorDetails/GetContractorDataDetails';
    this.getContractorUrl = this.baseApiUrl + '/ContractorDetails/GetContractorDetails';
    this.updateUserIdContractorDetailsApiUrl = this.baseApiUrl + '/ContractorDetails/UpdateUserIdContractorDetailsData';
    this.getUserIdContractorDetailsApiUrl = this.baseApiUrl + '/ContractorDetails/GetUserIdContractorDetailsData';
    this.getUserDataFromAppenateApiUrl = this.baseApiUrl + '/ContractorDetails/GetUsersFromAppenate';
  }


  postContractorDetails(body: ContractorDetailsModel, type: string) {
    try {
      return this.http.post(this.postcontractorDetailsApiUrl, body).toPromise();
    }
    catch (Ex) {
      throw Ex;
    }
  }


  // Delete data By recordid
  GetUserIDContractorDetails(email: string, type: string) {
    return this.http.get(this.updateUserIdContractorDetailsApiUrl + '/' + email + '/' + type).toPromise();
  }


  // Get data By recordid
  getContractorDetails(RecordId: number) {
    return this.http.get(this.getcontractorDtlsByrecordIdUrl + '/' + RecordId).toPromise();
  }

  // Delete data By recordid
  deleteContractorDetails(RecordId: number, type: string) {
    return this.http.get(this.deletecontractorDtlsByRecordId + '/' + RecordId + '/' + type).toPromise();
  }

  // Get data By recordid
  getContractorDataDetails(RecordId: number, FormId: string) {
    return this.http.get(this.getcontractordataDtlsByrecordIdUrl + '/' + RecordId + '/' + FormId);
  }



  // Get All Contractor Details
  getContractor(clientId: string, userrole: string, userEmail: string, sqlGlobalFilterCondition:string = '') {
    try {
      return this.http.get(this.getContractorUrl + '/' + clientId + '/' + userrole + '/' + userEmail + '/' + sqlGlobalFilterCondition).toPromise();
    } catch (Ex) {
      throw Ex;
    }
  }


  // Delete data By recordid
  updateUserIDContractorDetails(email: string, type: string) {
    debugger;
    return this.http.get(this.updateUserIdContractorDetailsApiUrl + '/' + email + '/' + type).toPromise();
  }


  // Get data By CompanyId and Integration key
  GetUserDataFromAppenate(CompanyId: number, IntegrationKey: string) {
    debugger;
    return this.http.get(this.getUserDataFromAppenateApiUrl + '/' + CompanyId + '/' + IntegrationKey).toPromise();;
   
  }
}
